import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureAccessService } from './feature-access.service';

export function featureAccessGuard(key: string): CanActivateFn {
  return () => {
    const svc = inject(FeatureAccessService);
    const router = inject(Router);
    if (svc.canSee(key)) return true;
    return router.createUrlTree(['/']);
  };
}
